import { FunctionComponent } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import SignInLayout from '../../components/SignInLayout/SignInLayout';

import SignInStaff from './SignInStaff/SignInStaff';
import SignInStudent from './SignInStudent/SignInStudent';
import CreateAccount from '../CreateAccount/CreateAccount';
import ProtectedRoute from '../ProtectedRoute/ProtectedRoute';

import './SignIn.scss';
import { useDpState } from '../../providers/DpStateProvider/DpStateProvider';
import { PageFooter } from '../../components';

const SignIn: FunctionComponent = () => {
  const { user } = useDpState();
  const { pathname } = useLocation();

  const footerLinks =
    pathname.toLowerCase().includes('staff') || pathname.toLowerCase().includes('create-account')
      ? [
          {
            content: 'Privacy Policy',
            url: 'https://education.scholastic.com/education/privacy-policy.html',
            className: 'customer-portal-sign-in__privacy--terms--link',
          },
          {
            content: 'Terms of Use',
            url: 'https://www.scholastic.com/terms.htm',
            className: 'customer-portal-sign-in__privacy--terms--link',
          },
        ]
      : [
          {
            content: 'Privacy Policy',
            url:
              'https://education.scholastic.com/education/privacy-policy/student-privacy-policy.html',
            className: 'customer-portal-sign-in__privacy--terms--link',
          },
          {
            content: 'Terms of Use',
            url: 'https://www.scholastic.com/terms.htm',
            className: 'customer-portal-sign-in__privacy--terms--link',
          },
        ];

  return (
    <>
      <SignInLayout>
        <Routes>
          <Route element={<ProtectedRoute isAllowed={!user} redirectPath="/" />}>
            <Route path="/" element={<SignInStudent />} />
            <Route path="/staff" element={<SignInStaff />} />
          </Route>
          <Route path="/create-account" element={<CreateAccount />} />
        </Routes>
      </SignInLayout>
      <PageFooter links={footerLinks} className="customer-portal-app__footer" />
    </>
  );
};

export default SignIn;
